import { REPORT_TYPES } from '../consts/reportTypes';

export const checkToRedirect = data => {
  let _link = '';

  if (data?.report_type === REPORT_TYPES.CONVERSION) {
    _link = `/project/quaters/${data.id}`;

    return _link;
  }

  if (
    data?.periods?.length > 1 ||
    (data?.periods?.length === 1 && data?.periods?.[0]?.report_progress_status !== 'Not started') ||
    data?.is_workflow_group
  )
    _link = `/project/quaters/${data.id}${data?.is_workflow_group ? `?type=grouped` : ''}`;
  else if (data?.periods?.length === 1)
    // AIFs is the entry step for scratch single-period projects. AddAIFs
    // (path /project/quaters/:wf/:periodId/add-aifs) renders the scratch
    // variant via its own `template_type === 'sratch'` check, so this URL
    // works for both flow types.
    _link = `/project/quaters/${data.id}/${data?.periods?.[0]?.id}/add-aifs`;
  else if (data?.periods?.length === 0) _link = `/project/quaters/${data.id}`;
  else _link = '';

  if (data?.workflow_group_id) {
    _link = `/project/quaters/${data?.workflow_group_id}?type=grouped`;
  }

  return _link;
};

export const checkToRedirectFileUpload = (data, periodId) => {
  // UploadFiles handles both scratch and automation periods (the page
  // branches on `previous_period_id` to detect initial setup). No more
  // separate /funds URL for scratch.
  return `/project/quaters/${data?.id}/${periodId}/upload-files`;
};
